<template>
  <span>
    <strong>{{geofence.name}}</strong>
    <small v-if="geofence.reference_location || geofence.city">
      <br v-if="!oneLine">
      ({{[geofence.city, geofence.reference_location].filter(Boolean).join(', ')}})
    </small>
    <small v-if="geofence.external_id">
      <br v-if="!oneLine">
      {{geofence.external_id || ''}}
    </small>
  </span>
</template>

<script>
export default {
  name: 'GeoFencesItemTitle',
  props: {
    geofence: {
      type: Object,
      default: () => {}
    },
    oneLine: {
      type: Boolean,
      default: true
    }
  }
}
</script>
